<div class="flex flex-col container box-border items-center gap-6 my-14 p-14">
    <div>
        <img width="800" src="/assets/images/error-outage.svg" />
    </div>
    <div data-testid="error-page-title" [ngSwitch]="activeStatus">
        <strong *ngSwitchCase="status.UnderMaintenance" class="mat-display-large mb-0">{{
            'COMMON.ERRORS.MAINTENANCE.TITLE' | translate
        }}</strong>
        <strong *ngSwitchCase="status.MajorOutage" class="mat-display-large mb-0">{{ 'COMMON.ERRORS.OUTAGE.TITLE' | translate }}</strong>
    </div>
    <div class="flex flex-col items-center gap-6">
        <div [ngSwitch]="activeStatus">
            <span *ngSwitchCase="status.UnderMaintenance">{{ 'COMMON.ERRORS.MAINTENANCE.CONTENT' | translate }}</span>
            <span *ngSwitchCase="status.MajorOutage">{{ 'COMMON.ERRORS.OUTAGE.CONTENT' | translate }}</span>
        </div>
        <div class="flex justify-center mt-6">
            <button mat-flat-button class="ca-button mt-auto" data-testid="reload-btn" (click)="reload()">
                <span>{{ 'BUTTON.RELOAD' | translate }}</span>
            </button>
        </div>
    </div>
</div>
